import React, { useState, useMemo } from 'react';
import './paginacao-icones.component.scss';
import IconesSVGComponent from '../svg-icon/svg-icon.component';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

type PaginacaoIconesProps = {
  setVal: (val: string) => void;
  originalData: string[];
}

function PaginacaoIconesComponent(props: PaginacaoIconesProps) {

  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);

  const filteredData = useMemo(() => {
    if (!searchQuery) return props.originalData;
    return props.originalData.filter(item =>
      item.toLowerCase().includes(searchQuery.toLowerCase()) // Example search criteria
    );
  }, [props.originalData, searchQuery]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredData.slice(startIndex, endIndex);
  }, [filteredData, currentPage, itemsPerPage]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1); // Reset page on new search
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className='paginacao-icones'>
      <div className="top flex flex-sp flex-cv">
        <p>
          *Procure o nome do ícone em inglês <br />
          <small>Quantidade de ícones: <strong>{props.originalData.length}</strong></small>
        </p>
        <div className="campo w50">
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small" className='select'>
            <InputLabel id="demo-select-small-label">Exibição por página</InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={itemsPerPage}
              label="Submenu"
              onChange={(event) => setItemsPerPage(parseInt(event.target.value.toString()))}
            >
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={500}>500</MenuItem>
              <MenuItem value={1000}>1000</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
      <input
        type="text"
        placeholder="Buscar ícone..."
        value={searchQuery}
        onChange={handleSearchChange}
      />

      <div className="list-icones">
        {/* Render paginatedData */}
        {paginatedData.map((item, index) => (
          <div key={index} className="icone" title={item} onClick={() => props.setVal(item)}>
            <IconesSVGComponent iconName={item}></IconesSVGComponent>
            <span>{item}</span>
          </div>
        ))}
      </div>

      <div className="paginacao">
        <p>Paginação:</p>
        {Array.from({ length: totalPages }, (_, i) => i + 1).map(pageNumber => (
          <button key={pageNumber} onClick={() => handlePageChange(pageNumber)}>
            {pageNumber}
          </button>
        ))}
      </div>
    </div>
  );
}

export default PaginacaoIconesComponent;
